import React from "react";
import ChatComponent from "Components/Chat";
import { UpOutlined, MinusOutlined, CloseOutlined } from "@ant-design/icons";
import api from "utils/api";
import { connect } from "react-redux";
import "./Chat.scss";
import Loader from "Components/Loader";

class ChatWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPatient: null,
      user_details: this.props.user_details,
    };
  }

  getToken() {
    let { chat_id, room_id } = this.state.selectedPatient || {};
    api.assign_chat({ chat_id, room_id }).then((res) => {
      let {
        data: {
          data: { care_admin_token },
        },
      } = res;
      if (care_admin_token) {
        this.setState({
          care_admin_token,
          room_id,
        });
      }
    });
  }

  handleChatExpandToggle() {
    this.setState((state) => ({
      chatExpandToggle: !state.chatExpandToggle,
    }));
  }

  closeChat() {
    typeof this.props.closeChat == "function" &&
      this.props.closeChat(this.state.selectedPatient);
  }

  componentDidMount() {
    this.getToken();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selectedPatient !== prevState.selectedPatient) {
      return {
        selectedPatient: nextProps.selectedPatient,
        chatExpandToggle: true,
      };
    } else return null;
  }

  render() {
    return (
      <div className="chat-widget-wrapper">
        <div
          className={`chat-toggle-container ${
            this.state.selectedPatient?.patient_identity ? " show" : " hide"
          }`}
        >
          <div className="chat-toggle-container-header">
            <div>{this.state.selectedPatient?.patient_name}</div>
            <div className="header-actions">
              {this.state.chatExpandToggle ? (
                <MinusOutlined
                  onClick={this.handleChatExpandToggle.bind(this)}
                />
              ) : (
                <UpOutlined onClick={this.handleChatExpandToggle.bind(this)} />
              )}
              <CloseOutlined onClick={this.closeChat.bind(this)} />
            </div>
          </div>
          <div
            className={`chat-widget-body ${
              this.state.chatExpandToggle ? " maximise" : "minimise"
            }`}
          >
            {this.state.selectedPatient?.patient_identity &&
            this.state.care_admin_token ? (
              <ChatComponent
                showHeader={false}
                style={{ height: "310px" }}
                token={this.state.care_admin_token}
                room_id={this.state.room_id}
                user={this.props.user_details}
                onCloseChannel={this.closeChat.bind(this)}
              />
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
  };
};
export default connect(mapStateToProps)(ChatWidget);
